import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { 
  LuCirclePlus, LuArrowRight, LuEye, LuEyeOff, 
  LuListOrdered, LuCopy, LuCheck, LuX, LuShare2,
  LuUsers, LuLock, LuLockOpen, LuExternalLink, LuClock, LuUser
} from "react-icons/lu";
import { 
  getFirestore, collection, getDocs, doc, getDoc, 
  query, where, onSnapshot, updateDoc 
} from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { app } from "../firebase";
import AgendaPage from "../components/Agenda";
import { useNavigate } from "react-router-dom";
import LoadingComLayout from "../components/LoadingComLayout";
import ModalAgendar from "../components/ModalAgendar";

const db = getFirestore(app);

// ... (MANTIVE OS ESTILOS DO MODAL DE BOAS-VINDAS ORIGINAIS AQUI) ...
const Overlay = styled.div` position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(31, 26, 64, 0.6); backdrop-filter: blur(4px); display: flex; justify-content: center; align-items: center; z-index: 9999; padding: 1rem; `;
const WelcomeModal = styled.div` background: white; width: 100%; max-width: 500px; border-radius: 1.5rem; padding: 2rem; position: relative; box-shadow: 0 10px 40px rgba(0,0,0,0.2); text-align: center; animation: slideUp 0.3s ease-out; @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } } `;
const CloseBtn = styled.button` position: absolute; top: 1rem; right: 1rem; background: transparent; border: none; cursor: pointer; color: #888; display: flex; &:hover { color: #333; } `;
const WelcomeIcon = styled.div` width: 60px; height: 60px; background-color: #eef4ff; color: #3a79ed; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 1.5rem auto; font-size: 1.8rem; `;
const WelcomeTitle = styled.h2` color: #1f1a40; font-size: 1.75rem; margin-bottom: 0.75rem; `;
const WelcomeText = styled.p` color: #666; font-size: 1rem; line-height: 1.5; margin-bottom: 2rem; `;
const LinkBox = styled.div` background-color: #f7f9fc; border: 1px dashed #cbd5e1; border-radius: 1rem; padding: 1rem; display: flex; align-items: center; gap: 0.75rem; margin-bottom: 2rem; position: relative; `;
const UrlText = styled.span` flex: 1; font-family: monospace; font-size: 0.9rem; color: #334155; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: left; `;
const CopyButton = styled.button` background-color: ${props => props.copied ? "#10b981" : "#3a79ed"}; color: white; border: none; padding: 0.5rem 1rem; border-radius: 0.5rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 0.5rem; transition: all 0.2s; font-size: 0.85rem; &:hover { filter: brightness(1.1); } `;

/* ===== LAYOUT GERAL ===== */
const Main = styled.main`
  flex: 1; padding: 2rem 4rem; display: flex; flex-direction: column; justify-content: flex-start; gap: 2rem; background-color: #f3f7ff; min-height: 100vh;
  @media (max-width: 1280px) { padding: 2rem; }
  @media (max-width: 768px) { padding: 1rem; gap: 1.25rem; }
`;

const LoadingWrapper = styled.div`
  width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; min-height: 60vh;
`;

const Header = styled.header`
  display: flex; justify-content: space-between; align-items: center; gap: 1rem;
  @media (max-width: 640px) { flex-direction: column; align-items: stretch; }
`;

const Title = styled.h2` font-size: 1.5rem; font-weight: 700; color: #1f1a40; @media (max-width: 1024px) { font-size: 1.75rem; } @media (max-width: 640px) { font-size: 1.5rem; } `;

const ButtonsRow = styled.div` display: flex; align-items: center; gap: 0.75rem; @media (max-width: 640px) { width: 100%; } `;

const Botao = styled.button`
  display: inline-flex; align-items: center; gap: 0.75rem; padding: 0.8rem 1.1rem; border-radius: 0.75rem; font-size: 0.95rem; color: #fff; background-color: #3a79ed; box-shadow: 0 4px 12px rgba(58, 136, 237, 0.3); font-weight: 600; cursor: pointer; border: none; transition: transform 0.15s ease, box-shadow 0.15s ease;
  &:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(58, 136, 237, 0.35); }
  @media (max-width: 640px) { width: auto; flex: 1 1 auto; justify-content: center; }
`;
const DetalhesBtn = styled(Botao)` background-color: #1f1a40; box-shadow: 0 4px 12px rgba(31, 26, 64, 0.2); display: none; @media (max-width: 640px) { display: inline-flex; } `;

/* ===== CARDS SUPERIORES ===== */
const CardsGrid = styled.section`
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 1rem;
  @media (max-width: 1280px) { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 920px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 520px) { grid-template-columns: 1fr; }
`;
const Card = styled.article`
  display: flex; flex-direction: column; justify-content: stretch; padding: 1.25rem 1.5rem; border-radius: 1.25rem; background: linear-gradient( 135deg, ${(props) => props.cor1 || "#3a79ed"}, ${(props) => props.cor2 || "#3a79ed"} ); color: ${(props) => props.texto || "white"}; min-height: 150px;
  h3 { font-size: 1rem; font-weight: 500; opacity: 0.95; margin: 0 0 0.5rem 0; }
`;
const StatValue = styled.span` font-size: 3rem; line-height: 1.1; font-weight: 800; @media (max-width: 1280px) { font-size: 2.5rem; } @media (max-width: 920px) { font-size: 2.25rem; } @media (max-width: 520px) { font-size: 2rem; } `;
const MoneyRow = styled.div` font-size: 2.5rem; font-weight: 800; display: flex; align-items: center; gap: 0.5rem; line-height: 1.1; @media (max-width: 1280px) { font-size: 2.1rem; } @media (max-width: 920px) { font-size: 1.9rem; } @media (max-width: 520px) { font-size: 1.7rem; } `;
const CardFooter = styled.div` margin-top: auto; display: flex; justify-content: flex-end; a { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.95rem; color: currentColor; opacity: 0.95; text-decoration: none; } `;

/* ===== ÁREA DE CONTEÚDO (AGENDA + FILA) ===== */
const ContentRow = styled.section`
  display: grid; grid-template-columns: 3fr 1fr; gap: 1.5rem;
  @media (max-width: 1280px) { grid-template-columns: 2.5fr 1fr; }
  @media (max-width: 1024px) { grid-template-columns: 1fr; }
`;

/* --- ESTILOS DO WIDGET DE FILA --- */
const FilaWidget = styled.div`
  background: white;
  border-radius: 1rem;
  border: 1px solid #e6ecf5;
  box-shadow: 0 6px 20px rgba(58,121,237,.06);
  display: flex; flex-direction: column;
  height: 65vh;
  overflow: hidden;
`;

const FilaHeader = styled.div`
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #eef2fb;
  display: flex; justify-content: space-between; align-items: center;
  
  h4 { margin: 0; display: flex; align-items: center; gap: 8px; font-size: 1rem; color: #1f1a40; }
`;

const FilaList = styled.div`
  flex: 1;
  padding: 1rem;
  overflow-y: auto;
  display: flex; flex-direction: column; gap: 0.75rem;

  /* Scrollbar bonita */
  &::-webkit-scrollbar { width: 5px; }
  &::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
`;

const MiniTicket = styled.div`
  background: ${(props) => props.bg || "#fff"};
  border: 1px solid ${(props) => props.borderColor || "#e2e8f0"};
  border-radius: 0.5rem;
  padding: 0.75rem;
  position: relative;
  transition: all 0.2s;
  
  &:hover { background: #f8fafc; }
`;

const MiniTicketTop = styled.div`
  display: flex; justify-content: space-between; align-items: flex-start;
  margin-bottom: 4px;
  font-weight: 700; font-size: 0.9rem; color: #1e293b;
`;

const MiniTicketInfo = styled.div`
  font-size: 0.75rem; color: #64748b;
  display: flex; flex-direction: column; gap: 2px;
  
  div { display: flex; align-items: center; gap: 4px; }
`;

const Badge = styled.span`
  background: ${(props) => props.bg}; color: ${(props) => props.color};
  padding: 2px 6px; border-radius: 4px; font-size: 0.7rem; font-weight: 700;
  text-transform: uppercase;
`;

const FilaFooter = styled.div`
  padding: 1rem;
  border-top: 1px solid #eef2fb;
  background: #fcfcfc;
`;

const ToggleFilaBtn = styled.button`
  background: ${(props) => props.aberta ? "#fee2e2" : "#dcfce7"};
  color: ${(props) => props.aberta ? "#ef4444" : "#16a34a"};
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 0.5rem;
  font-size: 0.75rem; font-weight: 700;
  cursor: pointer;
  display: flex; align-items: center; gap: 5px;
  transition: 0.2s;
  &:hover { filter: brightness(0.95); }
`;

const FullLinkBtn = styled.button`
  width: 100%;
  background: #3a79ed; color: white; border: none;
  padding: 0.75rem; border-radius: 0.5rem;
  font-weight: 600; font-size: 0.9rem;
  cursor: pointer;
  display: flex; justify-content: center; align-items: center; gap: 8px;
  transition: 0.2s;
  &:hover { background: #2a5ec2; }
`;

const EmptyFila = styled.div`
  text-align: center; color: #94a3b8; margin-top: 2rem;
  p { font-size: 0.9rem; }
`;

/* --- FIM ESTILOS WIDGET --- */

const AgendaWrapper = styled.div`
  width: 100%;
  height: 100%; /* Força preencher o container pai */
  overflow: hidden;
`;

const Section = styled.section`
  background: #fff; 
  border: 1px solid #e6ecf5; 
  border-radius: 1rem;
  box-shadow: 0 6px 20px rgba(58,121,237,.06);
  overflow: hidden;
  display: flex; flex-direction: column;
  height: 65vh;
`;

const SectionBody = styled.div`
  padding: 1rem; 
  display: flex; 
  flex-direction: column; 
  gap: 1rem;
  flex: 1; /* Cresce para ocupar altura da Section */
  min-height: 0; /* Importante para o scroll interno da agenda funcionar se necessário */
`;

const Toolbar = styled.div` background: #fff; border-bottom: 1px solid #eef2fb; padding: 1.25rem; display: flex; flex-direction: column; gap: 1rem; `;
const ToolbarTop = styled.div` display: flex; justify-content: space-between; align-items: center; `;
const ToolbarTitle = styled.div` display: flex; align-items: center; gap: 0.75rem; font-size: 1.1rem; font-weight: 700; color: #1f1a40; .count-badge { background: #e0f2fe; color: #0284c7; font-size: 0.8rem; padding: 2px 8px; border-radius: 12px; } `;

export default function ProprietarioPainel() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [clientesParceiros, setClientesParceiros] = useState(0);
  const [quantidadeServicos, setQuantidadeServicos] = useState(0);
  const [agendamentosHoje, setAgendamentosHoje] = useState(0);
  const [modalAberto, setModalAberto] = useState(false);
  const [barbeariaId, setBarbeariaId] = useState(null);
  const [faturamentoHoje, setFaturamentoHoje] = useState(0);
  const [mostrarFaturamento, setMostrarFaturamento] = useState(true);
  
  // States do Widget de Fila
  const [filaPreview, setFilaPreview] = useState([]);
  const [filaAberta, setFilaAberta] = useState(false);

  // Estado para o Modal de Boas-Vindas
  const [showWelcome, setShowWelcome] = useState(false);
  const [linkCopiado, setLinkCopiado] = useState(false);

  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (!currentUser) {
        navigate("/login");
        return;
      }

      setUser(currentUser);
      const uid = currentUser.uid;
      let barbeariaIdEncontrado = null;

      const q = query(collection(db, "barbearia"), where("criadorUid", "==", uid));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        barbeariaIdEncontrado = querySnapshot.docs[0].id;
      } else {
        const barbeariasSnapshot = await getDocs(collection(db, "barbearia"));
        for (const docBarbearia of barbeariasSnapshot.docs) {
          const barbeiroRef = doc(db, `barbearia/${docBarbearia.id}/barbeiros/${uid}`);
          const barbeiroSnap = await getDoc(barbeiroRef);
          if (barbeiroSnap.exists()) {
            barbeariaIdEncontrado = docBarbearia.id;
            break;
          }
        }
      }

      if (barbeariaIdEncontrado) {
        setBarbeariaId(barbeariaIdEncontrado);
        await buscarAgendamentosHoje(barbeariaIdEncontrado);
        await buscarFaturamentoHoje(barbeariaIdEncontrado);
        await buscarClientesParceiros(barbeariaIdEncontrado);
        await buscarQuantidadeServicos(barbeariaIdEncontrado);

        // ===== LÓGICA DE BOAS-VINDAS (PRIMEIRA VEZ) =====
        const welcomeKey = `welcome_seen_v1_${uid}`; 
        const jaViu = localStorage.getItem(welcomeKey);
        
        if (!jaViu) {
          setShowWelcome(true);
        }
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // ====== LÓGICA DO WIDGET DE FILA ======
  useEffect(() => {
    if (!barbeariaId) return;

    // 1. Escutar status da fila (Aberta/Fechada)
    const unsubStatus = onSnapshot(doc(db, "barbearia", barbeariaId), (docSnap) => {
        if (docSnap.exists()) {
            setFilaAberta(docSnap.data().filaAberta === true);
        }
    });

    // 2. Escutar itens da fila (Aguardando, Chamado, Em Atendimento)
    const qFila = query(
        collection(db, "barbearia", barbeariaId, "fila"), 
        where("status", "in", ["aguardando", "chamado", "em_atendimento"])
    );
    
    const unsubFila = onSnapshot(qFila, (snapshot) => {
        const itens = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        // Ordenar por hora de entrada
        itens.sort((a, b) => (a.dataEntrada?.seconds || 0) - (b.dataEntrada?.seconds || 0));
        setFilaPreview(itens);
    });

    return () => { unsubStatus(); unsubFila(); };
  }, [barbeariaId]);

  // ======================================

  const fecharBoasVindas = () => {
    if (user) localStorage.setItem(`welcome_seen_v1_${user.uid}`, "true");
    setShowWelcome(false);
  };

  const copiarLink = () => {
    const link = `https://${barbeariaId}.bigode.app`;
    navigator.clipboard.writeText(link).then(() => {
      setLinkCopiado(true);
      setTimeout(() => setLinkCopiado(false), 2000);
    });
  };

  const buscarFaturamentoHoje = async (barbeariaId) => {
    const hoje = getHojeISO();
    const qAg = query(
      collection(db, `barbearia/${barbeariaId}/agendamentos`),
      where("data", "==", hoje),
      where("status", "==", "confirmado")
    );
    const snapshot = await getDocs(qAg);
    let total = 0;
    for (const docAg of snapshot.docs) {
      const ag = docAg.data();
      const servicoId = ag.servicoId;
      if (servicoId) {
        const servicoRef = doc(db, `barbearia/${barbeariaId}/servico/${servicoId}`);
        const servicoSnap = await getDoc(servicoRef);
        if (servicoSnap.exists()) {
          const servico = servicoSnap.data();
          total += normalizeValor(servico.valor || servico.preco || 0);
        }
      }
    }
    setFaturamentoHoje(total);
  };

  function getHojeISO() {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function normalizeValor(raw) {
    if (typeof raw === "number") return raw;
    if (typeof raw === "string") {
      const n = Number(raw.replace(/[R$\s]/g, "").replace(",", "."));
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }

  const buscarClientesParceiros = async (barbeariaId) => {
    const agendamentosRef = collection(db, `barbearia/${barbeariaId}/agendamentos`);
    const snapshot = await getDocs(agendamentosRef);
    const uids = new Set();
    snapshot.forEach((docx) => {
      const data = docx.data();
      if (data.clienteId) uids.add(data.clienteId);
    });
    setClientesParceiros(uids.size);
  };

  const buscarAgendamentosHoje = async (barbeariaId) => {
    const hoje = getHojeISO();
    const qAg = query(
      collection(db, `barbearia/${barbeariaId}/agendamentos`),
      where("data", "==", hoje),
      where("status", "==", "confirmado")
    );
    const snapshot = await getDocs(qAg);
    setAgendamentosHoje(snapshot.size);
  };

  const buscarQuantidadeServicos = async (barbeariaId) => {
    const servicosRef = collection(db, `barbearia/${barbeariaId}/servico`);
    const snapshot = await getDocs(servicosRef);
    setQuantidadeServicos(snapshot.size);
  };

  return (
    <>
      <>
        {loading ? (
        // Renderiza o loading DENTRO do layout
        <LoadingWrapper>
           <LoadingComLayout /> 
        </LoadingWrapper>
      ) : (
        <Main>
          <Header>
            <Title>Bem-vindo de volta!</Title>
            <ButtonsRow>
              <DetalhesBtn onClick={() => navigate("/detalhamento")}>
                <LuListOrdered size={20} /> Detalhes
              </DetalhesBtn>
              <Botao onClick={() => setModalAberto(true)}>
                <LuCirclePlus size={20} /> Agendar
              </Botao>
            </ButtonsRow>
          </Header>

          <CardsGrid>
            <Card texto="white">
              <h3>Agendamentos Hoje</h3>
              <StatValue>{agendamentosHoje}</StatValue>
              <CardFooter>
                <a href="agenda-horarios"><LuArrowRight /> Ver mais</a>
              </CardFooter>
            </Card>
            <Card cor1="#e1ecff" cor2="#e1ecff" texto="#1d3161">
              <h3>Faturamento Hoje</h3>
              <MoneyRow>
                {mostrarFaturamento ? `R$ ${faturamentoHoje.toFixed(2)}` : "••••••••••••"}
                {mostrarFaturamento ? (
                  <LuEye size={28} style={{ cursor: "pointer" }} onClick={() => setMostrarFaturamento(false)} />
                ) : (
                  <LuEyeOff size={28} style={{ cursor: "pointer" }} onClick={() => setMostrarFaturamento(true)} />
                )}
              </MoneyRow>
              <CardFooter>
                <a href="/financeiro"><LuArrowRight /> Ver mais</a>
              </CardFooter>
            </Card>
            <Card cor1="#e1ecff" cor2="#e1ecff" texto="#1d3161">
              <h3>Clientes Parceiros</h3>
              <StatValue>{clientesParceiros}</StatValue>
              <CardFooter>
                <a href="/detalhamento"><LuArrowRight /> Ver mais</a>
              </CardFooter>
            </Card>
            <Card cor1="#e1ecff" cor2="#e1ecff" texto="#1d3161">
              <h3>Serviços</h3>
              <StatValue>{quantidadeServicos}</StatValue>
              <CardFooter>
                <a href="/servicos"><LuArrowRight /> Ver mais</a>
              </CardFooter>
            </Card>
          </CardsGrid>

          <ContentRow>
            {/* SEÇÃO DA AGENDA */}
            <Section>
              <Toolbar>
                <ToolbarTop>
                  <ToolbarTitle>
                    <LuListOrdered size={22} color="#3a79ed"/>
                    Agenda
                    <span className="count-badge">{agendamentosHoje} agendamentos</span>
                  </ToolbarTitle>
                </ToolbarTop>
              </Toolbar>
              <SectionBody>
                <AgendaWrapper>
                  <AgendaPage />
                </AgendaWrapper>
              </SectionBody>
            </Section>
            
            {/* WIDGET DA FILA DE ESPERA (VISUALIZAÇÃO APENAS) */}
            <FilaWidget>
                <FilaHeader>
                    <h4><LuUsers  size={22} color="#3a79ed"/> Fila de Espera</h4>
                </FilaHeader>

                <FilaList>
                    {!filaAberta && (
                        <div style={{background: '#fee2e2', color: '#ef4444', padding: '0.5rem', borderRadius: 6, fontSize: '0.8rem', textAlign: 'center', marginBottom: 10, fontWeight: 700}}>
                            FILA FECHADA
                        </div>
                    )}

                    {filaPreview.length === 0 ? (
                        <EmptyFila>
                            <LuClock size={32} />
                            <p>Fila vazia no momento.</p>
                        </EmptyFila>
                    ) : (
                        filaPreview.map((ticket, index) => {
                            const isAtendimento = ticket.status === 'em_atendimento';
                            const isChamado = ticket.status === 'chamado';
                            
                            return (
                                <MiniTicket 
                                    key={ticket.id} 
                                    bg={isAtendimento ? "#f8fafc" : isChamado ? "#ecfdf5" : "#fff"}
                                    borderColor={isAtendimento ? "#3a79ed" : isChamado ? "#34d399" : "#e2e8f0"}
                                    leftColor={isAtendimento ? "#3a79ed" : isChamado ? "#34d399" : "transparent"}
                                >
                                    <MiniTicketTop>
                                        <span>{ticket.clienteNome}</span>
                                        {isAtendimento ? (
                                            <Badge bg="#e0f2fe" color="#0284c7">Cortando</Badge>
                                        ) : isChamado ? (
                                            <Badge bg="#dcfce7" color="#16a34a">Chamando</Badge>
                                        ) : (
                                            <span style={{color: '#94a3b8', fontSize: '0.8rem'}}>#{index + 1}</span>
                                        )}
                                    </MiniTicketTop>
                                    <MiniTicketInfo>
                                        <div>{ticket.servicoNome}</div>
                                        {ticket.barbeiroNome ? (
                                             <div style={{color: '#3a79ed', fontWeight: 600}}>
                                                <LuUser size={10} /> {ticket.barbeiroNome}
                                             </div>
                                        ) : (
                                            <div><LuUser size={10} /> Qualquer barbeiro</div>
                                        )}
                                    </MiniTicketInfo>
                                </MiniTicket>
                            )
                        })
                    )}
                </FilaList>

                <FilaFooter>
                    <FullLinkBtn onClick={() => navigate('/fila')}>
                        Gerenciar Fila Completa <LuExternalLink size={16}/>
                    </FullLinkBtn>
                </FilaFooter>
            </FilaWidget>

          </ContentRow>
        </Main>
      )}
      </>

      {/* ===== MODAL DE AGENDAR (Manual) ===== */}
      {modalAberto && barbeariaId && (
        <ModalAgendar barbeariaId={barbeariaId} onClose={() => setModalAberto(false)} />
      )}

      {/* ===== MODAL DE BOAS-VINDAS (Primeira vez) ===== */}
      {showWelcome && barbeariaId && (
        <Overlay>
          <WelcomeModal>
            <CloseBtn onClick={fecharBoasVindas}><LuX size={24} /></CloseBtn>
            <WelcomeIcon><LuShare2 /></WelcomeIcon>
            <WelcomeTitle>Seu Link de Agendamento 🚀</WelcomeTitle>
            <WelcomeText>
              Sua barbearia está pronta! Para começar a receber agendamentos automáticos, 
              compartilhe seu <b>Link Exclusivo</b> com seus clientes no WhatsApp ou coloque na bio do Instagram.
            </WelcomeText>
            <LinkBox>
              <UrlText>{`https://${barbeariaId}.bigode.app`}</UrlText>
              <CopyButton onClick={copiarLink} copied={linkCopiado}>
                {linkCopiado ? <LuCheck size={16} /> : <LuCopy size={16} />}
                {linkCopiado ? "Copiado!" : "Copiar"}
              </CopyButton>
            </LinkBox>
            <Botao style={{ width: "100%", justifyContent: "center" }} onClick={fecharBoasVindas}>
              Entendi, vamos lá!
            </Botao>
          </WelcomeModal>
        </Overlay>
      )}
    </>
  );
}